export const fullFeatureList = [
  {
    id: 4,
    name: "dashboard",
    description: null,
    active: true,
    site: "com",
    attribute_class: "default",
    attribute_type: null,
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    label: null,
    feature_order: null,
    extra_destination_columns: null,
  },
  {
    id: 5,
    name: "excel",
    description: null,
    active: true,
    site: "com",
    attribute_class: "default",
    attribute_type: null,
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    label: null,
    feature_order: null,
    extra_destination_columns: null,
  },
  {
    id: 7,
    name: "runtime_item_groups",
    description: null,
    active: true,
    site: "com",
    attribute_class: "default",
    attribute_type: null,
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    label: null,
    feature_order: null,
    extra_destination_columns: null,
  },
  {
    id: 17,
    name: "broker",
    description: null,
    active: true,
    site: "com",
    attribute_class: "customer",
    attribute_type: "category",
    attribute_sub_type: "flat",
    attribute_associations: ["chain"],
    icon_name: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    label: null,
    feature_order: 3,
    extra_destination_columns: null,
  },
  {
    id: 20,
    name: "director",
    description: null,
    active: true,
    site: "com",
    attribute_class: "customer",
    attribute_type: "category",
    attribute_sub_type: "flat",
    attribute_associations: ["chain"],
    icon_name: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    label: null,
    feature_order: 1,
    extra_destination_columns: null,
  },
  {
    id: 21,
    name: "list_price",
    description: null,
    active: true,
    site: "com",
    attribute_class: "item",
    attribute_type: "one-to-one",
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    label: "List Price",
    feature_order: null,
    extra_destination_columns: null,
  },
  {
    id: 22,
    name: "product_hierarchy",
    description: null,
    active: true,
    site: "com",
    attribute_class: "item",
    attribute_type: "category",
    attribute_sub_type: "tree",
    attribute_associations: null,
    icon_name: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    label: "Product Hierarchy",
    feature_order: null,
    extra_destination_columns: null,
  },
  {
    id: 23,
    name: "regional",
    description: null,
    active: true,
    site: "com",
    attribute_class: "customer",
    attribute_type: "category",
    attribute_sub_type: "flat",
    attribute_associations: ["chain"],
    icon_name: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    label: null,
    feature_order: 2,
    extra_destination_columns: null,
  },
  {
    id: 29,
    name: "item_number",
    description: null,
    active: true,
    site: "com",
    attribute_class: "item",
    attribute_type: "one-to-one",
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    label: "Item Number",
    feature_order: null,
    extra_destination_columns: null,
  },
  {
    id: 30,
    name: "item_description",
    description: null,
    active: true,
    site: "com",
    attribute_class: "item",
    attribute_type: "one-to-one",
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    label: "Item Description",
    feature_order: null,
    extra_destination_columns: null,
  },
];

export const storeAttrOptions = [
  {
    id: 1,
    name: "lil_drug_chain_id",
  },
  {
    id: 2,
    name: "lil_drug_chain",
  },
  {
    id: 13,
    name: "broker_chain",
    featureTag: "broker",
    attribute_type: "category",
    active: true,
  },
  {
    id: 15,
    name: "director_chain",
    featureTag: "director",
    attribute_type: "category",
    active: true,
  },
  {
    id: 17,
    name: "regional_chain",
    featureTag: "regional",
    attribute_type: "category",
    active: true,
  },
  {
    id: 18,
    name: "chain_priority_chain",
    featureTag: "chain_priority",
    attribute_type: "category",
    active: true,
  },
];
export const storeGroupByOptions = [
  {
    id: 10,
    name: "lil_drug_chain",
  },
  {
    id: 11,
    name: "broker_chain",
    association: "chain",
  },
  {
    id: 13,
    name: "director_chain",
    association: "chain",
  },
  {
    id: 15,
    name: "regional_chain",
    association: "chain",
  },
  {
    id: 16,
    name: "chain_priority_chain",
    featureTag: "chain_priority",
    association: "chain",
  },
];
export const itemAttrOptions = [
  {
    id: 2,
    name: "list_price",
    featureTag: "list_price",
    label: "List Price",
    attribute_type: "one-to-one",
    active: true,
  },
  {
    id: 3,
    name: "product_hierarchy_level_1",
    featureTag: "product_hierarchy",
    label: "Product Hierarchy Category",
    attribute_type: "category",
    active: true,
  },
  {
    id: 5,
    name: "item_number",
    featureTag: "item_number",
    label: "LDS Item Number",
    attribute_type: "one-to-one",
    active: true,
  },
  {
    id: 6,
    name: "item_description",
    featureTag: "item_description",
    label: "LDS Item Description",
    attribute_type: "one-to-one",
    active: true,
  },
  {
    id: 7,
    name: "tier",
    featureTag: "tier",
    label: "Profit Center ",
    attribute_type: "category",
    active: true,
  },
  {
    id: 8,
    name: "profit_center",
    featureTag: "profit_center",
    label: "Tier ",
    attribute_type: "category",
    active: true,
  },
];
export const storeFilterOptions = [
  {
    id: 5,
    label: "Chain Broker",
    source: "parameters.customer_filtering.broker_chain_id",
    reference: "lil_drug_broker",
    display_field: "name",
    id_field: "id",
    name: "broker_chain",
    athena_column_name: "broker_chain_id",
    is_disabled: true,
    featureTag: "broker",
  },
  {
    id: 7,
    label: "Chain Director",
    source: "parameters.customer_filtering.director_chain_id",
    reference: "lil_drug_director",
    display_field: "name",
    id_field: "id",
    name: "director_chain",
    athena_column_name: "director_chain_id",
    is_disabled: true,
    featureTag: "director",
  },
  {
    id: 7,
    label: "Chain Regional",
    source: "parameters.customer_filtering.regional_chain_id",
    reference: "lil_drug_regional",
    display_field: "name",
    id_field: "id",
    name: "regional_chain",
    athena_column_name: "regional_chain_id",
    is_disabled: true,
    featureTag: "regional",
  },
  {
    id: 8,
    label: "Chain Priority",
    source: "parameters.customer_filtering.chain_priority_id",
    reference: "lil_drug_chain_priority",
    display_field: "name",
    id_field: "id",
    name: "chain_priority",
    athena_column_name: "chain_priority_chain_id",
    is_disabled: true,
    featureTag: "chain_priority",
  },
];
export const itemGroupColumnOptions = [
  {
    id: 1,
    name: "product_hierarchy_level_1",
    featureTag: "product_hierarchy",
  },
  {
    id: 2,
    name: "tier",
    featureTag: "tier",
  },
  {
    id: 3,
    name: "profit_center",
    featureTag: "profit_center",
  },
];
export const runtimeItemGroupFilterOptions = [
  {
    id: 1,
    label: "Product Hierarchy",
    source: "parameters.item_filtering.product_hierarchy_id",
    reference: "lil_drug_product_hierarchy",
    display_field: "name_path",
    id_field: "id",
    name: "product_hierarchy",
    athena_column_name: "product_hierarchy_id",
    is_disabled: true,
    featureTag: "product_hierarchy",
  },
  {
    id: 2,
    label: "Tier",
    source: "parameters.item_filtering.tier_id",
    reference: "lil_drug_tier",
    display_field: "name_path",
    id_field: "id",
    name: "tier",
    athena_column_name: "tier_id",
    is_disabled: true,
    featureTag: "tier",
  },
  {
    id: 3,
    label: "Profit Center",
    source: "parameters.item_filtering.profit_center_id",
    reference: "lil_drug_profit_center",
    display_field: "name_path",
    id_field: "id",
    name: "profit_center",
    athena_column_name: "profit_center_id",
    is_disabled: true,
    featureTag: "profit_center",
  },
];
